// extracted by mini-css-extract-plugin
module.exports = {"formInput":"Form_formInput__I6fNn","formSubmit":"Form_formSubmit__oPM13"};